import {
  Box,
  Button,
  Grid,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";

export default function BarraTitulo({
  title = "",
  subTitle = "",
  component = false,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      sx={{ marginBottom: "0.25rem" }}
      justifyContent={"space-between"}
    >
      <Grid
        size={{
          xs: 12,
          sm: component ? 8 : 12,
        }}
      >
        <Box
          sx={[
            {
              pt: 1,
            },
            isMobile
              ? {
                  pb: 2,
                }
              : {
                  pb: 0,
                },
          ]}
        >
          <Typography
            color="primary"
            variant="h4"
            component="h2"
            sx={{ fontFamily: "Bebas Neue", fontSize: "1.9em" }}
          >
            {title}
          </Typography>
          <Typography color="textSecondary" variant="subtitle1" gutterBottom>
            {subTitle}
          </Typography>
        </Box>
      </Grid>
      {component && (
        <Grid
          size={{
            xs: 12,
            sm: isMobile ? 12 : 3,
          }}
        >
          <Box
            sx={[
              {
                display: "flex",
                width: "auto",
              },
              isMobile
                ? {
                    marginBottom: "2rem",
                  }
                : {
                    marginBottom: "0rem",
                  },
              isMobile
                ? {
                    justifyContent: "center",
                  }
                : {
                    justifyContent: "flex-end",
                  },
            ]}
          >
            <CompRelatorios />
          </Box>
        </Grid>
      )}
    </Grid>
  );
}

const CompRelatorios = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        aria-controls="menu-list-grow"
        aria-haspopup="true"
        variant="outlined"
        fullWidth={isMobile}
        onClick={handleClick}
        sx={{
          fontSize: "100%",
          minWidth: "8rem",
          color: "#253257",
          "&:hover": {
            color: "#F2C26A",
            background: "transparent",
          },
        }}
      >
        Relatórios
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <NavLink to="/CustomerSalesByType" style={{ textDecoration: "none" }}>
          <MenuItem
            onClick={handleClose}
            sx={{
              fontSize: "100%",
              minWidth: "8rem",
              color: "#253257",
              "&:hover": {
                color: "#F2C26A",
                background: "transparent",
              },
            }}
          >
            Vendas por cliente
          </MenuItem>
        </NavLink>
      </Menu>
    </>
  );
};
